// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TIsRealtyChangesExistsModel,
  IMappers,
  TIsRealtyChangesExistsResponse,
  TIsRealtyChangesExistsResponse_1,
  TIsRealtyChangesExistsResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TIsRealtyChangesExistsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v1/is-realty-changes-exists/',
} as TIsRealtyChangesExistsModel;

export function createIsRealtyChangesExistsModel(): TIsRealtyChangesExistsModel {
  return {
    ...defaultConfig,
  };
}

export interface IIsRealtyChangesExistsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchIsRealtyChangesExists<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IIsRealtyChangesExistsOptions<TResponse200, TResponse400>): Promise<
  TIsRealtyChangesExistsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createIsRealtyChangesExistsModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TIsRealtyChangesExistsResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TIsRealtyChangesExistsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TIsRealtyChangesExistsResponse;
}
